import { HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { LoggingService } from '../shared/services/logging/logging.service';

@Injectable()
export class CacheBusterInterceptor implements HttpInterceptor {
    /**
     *
     */
    constructor(@Inject(LoggingService) private log: LoggingService) {}

    public intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        // Clone the request to add the new header
        let clonedRequest;
        this.log.verbose({ type: 'CacheBusterInterceptor', url: req.url });
        if (req.url.indexOf('.html') >= 0) {
            this.log.verbose({
                type: 'CacheBusterInterceptor:busting',
                url: req.url
            });
            //  clonedRequest = req.clone({url: req.url.concat()});
            const version = new HttpParams();
            version.append('v', environment.version);
            clonedRequest = req.clone({ params: version });
        } else {
            clonedRequest = req;
        }

        // Pass the cloned request instead of the original request to the next handle
        // return next.handle(clonedRequest)
        return next.handle(clonedRequest);
    }
}
